/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} PendingInputs */

const en_pending = /** @type {(inputs: PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pending...`)
};

const fr_pending = /** @type {(inputs: PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En attente...`)
};

const de_pending = /** @type {(inputs: PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausstehend...`)
};

const it_pending = /** @type {(inputs: PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In attesa di...`)
};

const ru_pending = /** @type {(inputs: PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В ожидании...`)
};

const es_pending = /** @type {(inputs: PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pendiente...`)
};

const zh_cn2_pending = /** @type {(inputs: PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`待办的...`)
};

const ja_pending = /** @type {(inputs: PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保留中...`)
};

const hi_pending = /** @type {(inputs: PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लंबित...`)
};

const pt_pt2_pending = /** @type {(inputs: PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pendente...`)
};

/**
* | output |
* | --- |
* | "Pending..." |
*
* @param {PendingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const pending = /** @type {((inputs?: PendingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<PendingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_pending(inputs)
	if (locale === "de") return de_pending(inputs)
	if (locale === "it") return it_pending(inputs)
	if (locale === "ru") return ru_pending(inputs)
	if (locale === "es") return es_pending(inputs)
	if (locale === "zh-CN") return zh_cn2_pending(inputs)
	if (locale === "ja") return ja_pending(inputs)
	if (locale === "hi") return hi_pending(inputs)
	if (locale === "pt-PT") return pt_pt2_pending(inputs)
	return en_pending(inputs)
});